import React from "react";
import Header from "@/components/Header";
import HelpFab from "@/components/HelpFab";

export default function CompensationPlan() {
  return (
    <div className="min-h-screen bg-canvas" data-testid="compensation-page">
      <Header variant="public" />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8 sm:py-10">
        <div
          className="rounded-2xl overflow-hidden border-2 border-[#8D1CEB]/25 shadow-[0_24px_70px_-24px_rgba(141,28,235,0.45)] bg-white"
          data-testid="comp-incentives-wrap"
        >
          <img
            src="/compensation/incentives.png"
            alt="CaryPact · BOT Chain — Multi-Dimensional Active Incentives Driving Global CA Consensus (VIP computing power promotion, active hashrate output, staking VIP level rewards, VIP level rewards table V1–V10, and reward formulas)"
            className="w-full h-auto block"
            data-testid="comp-incentives-img"
          />
        </div>
      </div>
      <HelpFab />
    </div>
  );
}
